import React from "react"
import {Col, Row} from "react-bootstrap"
import TargetBoxSkeleton from "./TargetBoxSkeleton";

export default function TargetsSkeleton() {

    return(
        <div>
            <div className="goals-section">
                <Row>
                    <Col md={6}>

                        <TargetBoxSkeleton
                            GoalHeading="Quarterly Targets"
                            GoalEmptyHeading="Add Quaterly Targets"
                            boxColor="white"
                            iconColor="white"
                            Color="#F7E5FF"
                            backgroundColor="#BBBBBB05"
                        />

                        {
                            [1,2,3,4].map((v,i)=>{
                                return(
                                    <TargetBoxSkeleton
                                        GoalHeading={` Monthly Targets`}
                                        GoalEmptyHeading={` Target`}
                                        boxColor="white"
                                        iconColor="#00AEFF"
                                        Color="#F7E5FF"
                                        backgroundColor="#00AEFF05"
                                    />
                                )
                            })
                        }


                        {/*<TargetBox*/}
                        {/*    GoalHeading="February Monthly Targets"*/}
                        {/*    GoalEmptyHeading="Add February Target"*/}
                        {/*    boxColor="white"*/}
                        {/*    iconColor="#00AEFF"*/}

                        {/*    Color="#F7E5FF"*/}
                        {/*    backgroundColor="#00AEFF05"*/}
                        {/*/>*/}
                        {/*<TargetBox*/}
                        {/*    GoalHeading="March Monthly Targets"*/}
                        {/*    GoalEmptyHeading="Add March Target"*/}
                        {/*    boxColor="white"*/}
                        {/*    iconColor="#00AEFF"*/}
                        {/*    Color="#F7E5FF"*/}
                        {/*    backgroundColor="#00AEFF05"*/}
                        {/*/>*/}
                    </Col>
                    <Col md={6}>
                        {/*Work Here*/}
                        {
                            [1,2,3,4].map((v, i) => {
                                console.log("ThisIsValuesMonth", v);
                                return (
                                    <TargetBoxSkeleton
                                        key={`week of`}
                                        GoalHeading={`Week of `}
                                        GoalEmptyHeading="No Weekly Goals"
                                        boxColor="white"
                                        iconColor="#DCAB43"
                                        Color="#F7E5FF"
                                        backgroundColor="#FFE20405"
                                    />
                                );
                            })
                        }

                    </Col>
                </Row>

            </div>
        </div>
    )
}